import React from 'react';
import { Box, Typography } from '@mui/material';

export interface InstrumentItemProps {
  image?: string;
  name: string;
}

export const InstrumentItem: React.FC<InstrumentItemProps> = ({ image, name }) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      {!!image && <img src={image} alt={`${name} instrument icon`} className="size-6" />}
      <Typography variant="body-500">{name}</Typography>
    </Box>
  );
};
